import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import {setupCsrfGuards} from './csrf';

InertiaProgress.init();
setupCsrfGuards();

createInertiaApp({
    resolve: name => import(`./../modules/${name}.vue`),
    title: title => (title ? `${title} - KAPAUDIT` : 'KAPAUDIT'),
    setup({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .mixin({methods: {route}})
            .mount(el);
    },
});
